// M66 — Buy Together
// - Toggle between collapsed summary and expanded card view
// - Recalculate bundle total as companion checkboxes are toggled
// - On submit, POST source variant + all checked companions to /cart/add.js
(() => {
  const LABEL_SHOW = 'Click to Show Products ▼'; // ▼
  const LABEL_HIDE = 'Click to Hide Products ▲'; // ▲

  const formatMoney = (cents) => {
    // Keep formatting simple and consistent with Shopify USD defaults.
    const dollars = (Number(cents) / 100).toFixed(2);
    return '$' + dollars.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const init = (root) => {
    const sourcePrice = Number(root.dataset.sourcePrice || 0);
    const sourceVariantId = Number(root.dataset.sourceVariant || 0);
    const toggleBtn = root.querySelector('[data-buy-together-toggle]');
    const toggleLabel = root.querySelector('[data-buy-together-toggle-label]');
    const expanded = root.querySelector('[data-buy-together-expanded]');
    const summary = root.querySelector('[data-buy-together-summary]');
    const checkboxes = root.querySelectorAll('.buy-together__checkbox');
    const totals = root.querySelectorAll('[data-buy-together-total]');
    const submitBtn = root.querySelector('[data-buy-together-submit]');
    const errorEl = root.querySelector('[data-buy-together-error]');

    // --- Total calculation ---
    const recalcTotal = () => {
      let cents = sourcePrice;
      checkboxes.forEach((cb) => {
        if (cb.checked) cents += Number(cb.dataset.variantPrice || 0);
      });
      const formatted = formatMoney(cents);
      totals.forEach((el) => { el.textContent = formatted; });
    };

    checkboxes.forEach((cb) => cb.addEventListener('change', recalcTotal));

    // --- Variant select (companions with multiple variants) ---
    // Updates the owning checkbox's data-variant-id / data-variant-price, swaps
    // the visible card price, then triggers the total recalc.
    root.querySelectorAll('[data-buy-together-variant-select]').forEach((select) => {
      select.addEventListener('change', () => {
        const card = select.closest('.buy-together__card');
        if (!card) return;
        const cb = card.querySelector('.buy-together__checkbox');
        const priceEl = card.querySelector('[data-buy-together-card-price]');
        const opt = select.options[select.selectedIndex];
        if (cb) {
          cb.dataset.variantId = opt.value;
          cb.dataset.variantPrice = opt.dataset.price || '0';
        }
        if (priceEl) priceEl.textContent = formatMoney(opt.dataset.price || 0);
        recalcTotal();
      });
      // Clicks on the select shouldn't toggle the surrounding label's checkbox.
      select.addEventListener('click', (e) => e.stopPropagation());
    });

    // --- Expand / collapse ---
    if (toggleBtn && expanded) {
      toggleBtn.addEventListener('click', () => {
        const isExpanded = !expanded.hidden;
        expanded.hidden = isExpanded;
        toggleBtn.setAttribute('aria-expanded', String(!isExpanded));
        if (toggleLabel) toggleLabel.textContent = isExpanded ? LABEL_SHOW : LABEL_HIDE;
      });
    }

    // --- Submit: add source + checked companions to cart ---
    if (submitBtn) {
      submitBtn.addEventListener('click', async (event) => {
        event.preventDefault();
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

        const items = [];
        if (sourceVariantId) items.push({ id: sourceVariantId, quantity: 1 });
        checkboxes.forEach((cb) => {
          if (cb.checked) items.push({ id: Number(cb.dataset.variantId), quantity: 1 });
        });
        if (items.length === 0) {
          if (errorEl) { errorEl.textContent = 'Select at least one item to add.'; errorEl.hidden = false; }
          return;
        }

        submitBtn.disabled = true;
        const originalLabel = submitBtn.textContent;
        submitBtn.textContent = 'Adding…';

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!response.ok) {
            const payload = await response.json().catch(() => ({}));
            throw new Error(payload?.description || payload?.message || `Unable to add to cart (HTTP ${response.status}).`);
          }
          // Refresh cart drawer / count. Fall back to /cart if no drawer claims the event.
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => {
            if (!document.querySelector('cart-drawer[open], [data-cart-drawer-open]')) {
              window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
            }
          }, 400);
        } catch (err) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
          if (errorEl) { errorEl.textContent = err.message || 'Something went wrong. Please try again.'; errorEl.hidden = false; }
        }
      });
    }

    recalcTotal();
  };

  document.querySelectorAll('[data-buy-together]').forEach(init);

  // Re-init when a section reloads in the theme editor.
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-buy-together]').forEach(init);
  });
})();
